<mat-toolbar class="header notranslate">

  <app-logo-title></app-logo-title>

  <cmn-header-nav
    [items]="navItems$ | async"
    [activeValue]="activeTab$ | async"
    [labelsFrom]="'s'"
    (select)="onNavigate($event)">
  </cmn-header-nav>

  <div class="authentication">
    <cmn-auth-user-chip [menu]="menuHeader" [showName]="(size$ | async).more('m')">
    </cmn-auth-user-chip>
  </div>

</mat-toolbar>

<mat-menu #menuHeader="matMenu">

  @if (!(size$ | async).more('m')) {
    <h3 class="user-name">
      <cmn-auth-user-name [showAvatar]="false"></cmn-auth-user-name>
    </h3>
  }

  <button mat-menu-item (click)="onSettings()" class="button-action">
    <mat-icon>settings</mat-icon>
    <span>{{ 'term.settings' | translate }}</span>
  </button>

  <button mat-menu-item (click)="onChangePassword()" class="button-action">
    <mat-icon>vpn_key</mat-icon>
    <span>{{ 'action.change-password' | translate }}</span>
  </button>

  <button mat-menu-item (click)="onOpenAboutProgram()" class="button-action">
    <mat-icon>event_note</mat-icon>
    <span>{{ 'version.about' | translate }}</span>
  </button>

  <button mat-menu-item (click)="onExit()" class="button-action">
    <mat-icon>exit_to_app</mat-icon>
    <span>{{ 'term.exit' | translate }}</span>
  </button>

</mat-menu>
